/**
 * Client-safe environment configuration.
 *
 * Keeps only the values that are SAFE to ship to the browser. Anything
 * sensitive or server-only lives in `app/.server/config/env.ts`. The previous
 * single-file design used a runtime `isServerEnvironment` spread that Rollup
 * could not tree-shake, which leaked server-only configuration key names into
 * client chunks via the logger import graph.
 *
 * Vite replaces `import.meta.env.DEV` and `import.meta.env.VITE_*` with
 * literals at build time, so this module compiles down to a small object of
 * booleans on the client.
 */

const isDevelopment = import.meta.env.DEV;
const isProduction = !isDevelopment;

const showComponentErrorsRaw = import.meta.env.VITE_SHOW_COMPONENT_ERRORS;

export interface EnvConfig {
  isDevelopment: boolean;
  isProduction: boolean;
  /**
   * Render dev-only error banners inside section error boundaries.
   * Default: true in development, false in production.
   * Override via `VITE_SHOW_COMPONENT_ERRORS=true|false`.
   */
  showComponentErrors: boolean;
}

export const env: EnvConfig = {
  isDevelopment,
  isProduction,
  showComponentErrors:
    showComponentErrorsRaw !== undefined
      ? showComponentErrorsRaw === 'true'
      : isDevelopment,
} as const;
